<template>
  <ul class="bucket_folder_list">
    <li v-for="parent in node" :key="parent.id" class="bucket_folder_list_item" :class="parent.sub_folders.length > 0 ? 'sub_folder_dd' : ''">
      <div class="bucket_folder_name_wrp" :id="'sub_bucket' + parent.id">
         <span class="show_sub_bucket_list_icon" v-if="parent.sub_folders.length > 0">
          <i class="fa fa-angle-double-right" aria-hidden="true" @click="toggleForShowSubFolder(parent.id)"></i>
            <!-- <i class="fa fa-chevron-right" aria-hidden="true" @click="toggleForShowSubFolder(parent.id)"></i> -->
         </span>
         <router-link :to="{name : 'bucketDetails', params: {bucketId: parent.id}}">
            <i class="fa fa-folder mr-2" aria-hidden="true"></i>
            <span class="bucket_folder_list_name">{{ parent.name }}</span>
         </router-link>
        <div class="bucket_option_dd dropdown">
          <i
            class="fa fa-caret-square-o-down"
            aria-hidden="true"
            data-toggle="dropdown"
          ></i>
          <ul class="dropdown-menu bucket_option_list">
            <li
              class="bucket_option_item"
              @click="uploadPaperPopup(parent.id)"
            >
              Upload Paper
            </li>
            <li
              class="bucket_option_item"
              @click="openRenameBucketPopup(parent)"
            >
              Rename
            </li>
            <li
              class="bucket_option_item"
              @click="createCiteForPapersMethod(parent)"
            >
              Cite
            </li>
            <li
              class="bucket_option_item"
              @click="addNewSubBucketFolderMethod(parent.id)"
            >
              Add Sub Shelf
            </li>
            <li
              class="bucket_option_item"
              @click="removeBucketPopupOpenMethod(parent.id)"
            >
              Remove
            </li>
          </ul>
        </div>
      </div>
      <template v-if="parent.sub_folders && parent.sub_folders.length > 0">
        <transition name="fade">
          <ul class="bucket_folder_list">
            <li
              class="bucket_folder_list_item"
              v-for="child in parent.sub_folders"
              :key="child.id"
              :class="child.sub_folders.length > 0 ? 'sub_folder_dd' : ''"
            >
            <template v-if="child.is_folder">
              <div class="bucket_folder_name_wrp" :id="'sub_bucket' + child.id">
              <span class="show_sub_bucket_list_icon" v-if="child.sub_folders.length > 0">
                <i class="fa fa-angle-double-right" aria-hidden="true" @click="toggleForShowSubFolder(child.id)"></i>
                  <!-- <i class="fa fa-chevron-right" aria-hidden="true" @click="toggleForShowSubFolder(child.id)"></i> -->
              </span>
               <router-link :to="{name : 'bucketDetails', params: {bucketId: child.id}}">
                  <i class="fa fa-folder mr-2" aria-hidden="true"></i>
                  <span class="bucket_folder_list_name">{{ child.name }}</span>
                </router-link>
                <div class="bucket_option_dd dropdown">
                  <i
                    class="fa fa-caret-square-o-down"
                    aria-hidden="true"
                    data-toggle="dropdown"
                  ></i>
                  <ul class="dropdown-menu bucket_option_list">
                    <li
                      class="bucket_option_item"
                      @click="uploadPaperPopup(child.id)"
                    >
                      Upload Paper
                    </li>
                    <li
                      class="bucket_option_item"
                      @click="openRenameBucketPopup(child)"
                    >
                      Rename
                    </li>
                    <li
                      class="bucket_option_item"
                      @click="createCiteForPapersMethod(child)"
                    >
                      Cite
                    </li>
                    <li
                      class="bucket_option_item"
                      @click="addNewSubBucketFolderMethod(child.id)"
                    >
                      Add Sub Shelf
                    </li>
                    <li
                      class="bucket_option_item"
                      @click="removeBucketPopupOpenMethod(child.id)"
                    >
                      Remove
                    </li>
                  </ul>
                </div>
              </div>
              </template>
              <node v-if="child.sub_folders" :node="child.sub_folders"></node>
            </li>
          </ul>
        </transition>
      </template>
    </li>
  <!-- Remove Bucket Popup Code Here -->
  <remove-bucket v-bind:removeBucketID="removeBucketId" v-if="removeBucketPopupState"></remove-bucket>
  <!-- Remove Bucket Popup Code Here -->
  <!-- Rename Bucket Popup Code Here -->
  <rename-bucket v-if="updateBucketPopupState" v-bind:updateBucketDETAIL="updateBucketDetail"></rename-bucket>
  <!-- Rename Bucket Popup Code Here -->
  <new-sub-bucket-folder v-if="newSubBucketFolderPopupState" v-bind:newSubBucketFolderID="newSubBucketFolderId">
  </new-sub-bucket-folder>
  <upload-paper v-if="uploadPaperState" :uploadPaperFolderID="uploadPaperFolderId"></upload-paper>
  <cite-for-all-paper v-if="createCiteForAllPaperState" :parentDATA="parentData"></cite-for-all-paper>
  </ul>
</template>
<script>
/*eslint-disable */
const $ = window.jQuery = require('jquery');
import { bus } from "@/main";
import removeBucket from "./delete-bucket";
import renameBucketname from "./rename-bucket";
import newSubBucketFolder from "./new-subbucket-folder";
import uploadPaper from './upload-papers';
import createCiteForAllPaper from '../create-citation-for-all-papers';
export default {
  name: "node",
  props: {
    node: Array,
  },
  components: {
    "new-sub-bucket-folder": newSubBucketFolder,
    "rename-bucket": renameBucketname,
    "remove-bucket": removeBucket,
    "upload-paper": uploadPaper,
    'cite-for-all-paper' : createCiteForAllPaper
  },
  data() {
    return {
      itemDetails: "",
      removeBucketId: "",
      removeBucketPopupState: "",
      updateBucketDetail: "",
      updateBucketPopupState: "",
      newSubBucketFolderPopupState: "",
      newSubBucketFolderId: "",
      activeBucketId:"",
      uploadPaperState:false,
      uploadPaperFolderId:'',
      createCiteForAllPaperState:false,
      parentData:null
    };
  },
  mounted() {
    bus.$on('uploadPaperStateBus', (data) => {
      this.uploadPaperState = data;
    });
    bus.$on('newSubBucketFolderPopupStateBus', (data) => {
      this.newSubBucketFolderPopupState = data;
    });
    bus.$on('removeBucketPopupStateBus', (data) => {
      this.removeBucketPopupState = data;
    });
    bus.$on('updateBucketPopupStateBus', (data) => {
      this.updateBucketPopupState = data;
    });
    bus.$on('createCiteForAllPaperStateBus', (data) => {
      this.createCiteForAllPaperState = data;
    });
  },
  methods: {
    toggleForShowSubFolder(id){
        let para = document.getElementById("sub_bucket" + id);
        para.parentElement.classList.toggle("show_sub_bucket")
        let listItems = document.querySelectorAll('.bucket_folder_list .bucket_folder_list_item.show_sub_bucket');
        $('.allfoldercollapsed').removeClass('open');
        listItems.forEach(function (li) {
            $('.allfoldercollapsed').addClass('open');
        });
    },
    bucketDetailRouting(bucketID) {
      if (bucketID != this.$route.params.bucketId) {
        this.activeBucketId = bucketID
        this.$router.push({
          name: "bucketDetails",
          params: { bucketId: bucketID },
        });
        this.$store
          .dispatch("getBucketDetailsByIdOfAwerackFun", { id: bucketID })
          .then((res) => {})
          .catch((err) => {});
      }
    },
    removeBucketPopupOpenMethod(itemId) {
      this.removeBucketId = itemId;
      this.removeBucketPopupState = true;
      document.body.classList.add('body_right_scroll_remove')
    },
    openRenameBucketPopup(data) {
      this.updateBucketDetail = data;
      this.updateBucketPopupState = true;
      document.body.classList.add('body_right_scroll_remove')
    },
    addNewSubBucketFolderMethod(id) {
      this.newSubBucketFolderPopupState = true;
      this.newSubBucketFolderId = id;
      document.body.classList.add('body_right_scroll_remove')
    },
    uploadPaperPopup(id){
      this.uploadPaperState = true;
      this.uploadPaperFolderId = id;
      document.body.classList.add('body_right_scroll_remove')
    },
    createCiteForPapersMethod(data){
      this.createCiteForAllPaperState = true;
      this.parentData = data;
      document.body.classList.add('body_right_scroll_remove')
    }
  },
};
</script>
<style lang="scss" scoped>
.bucket_option_wrp {
  margin-bottom: 15px;
  .bucket_folder_list {
    margin: 0;
    padding-left: 20px;
    .bucket_folder_list_item {
      color: #d6d6d6;
      font-size: 16px;
      margin-top: 15px;
      position: relative;
      cursor: pointer;
      .bucket_folder_name_wrp {
        position: relative;
        padding-right: 20px;
        a {
          display: flex;
          line-height: 1;
          align-items: baseline;
          color: #ffe9e9;
          text-decoration: none;
          &:hover,
          &.router-link-exact-active {
            color: #ffd700;
            .fa.fa-folder,
            .bucket_folder_list_name {
              color: #ffd700;
            }
          }
          .fa.fa-folder {
            color: #ffe9e9;
          }
        }
      }
      .bucket_folder_list_name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        color: #ffe9e9;
      }
      .bucket_folder_name_wrp:hover > .bucket_option_dd {
        display: block;
      }
      .bucket_option_dd {
        position: absolute;
        top: 0;
        right: 0;
        display: none;
        .fa-caret-square-o-down {
          font-size: 18px;
          color: #ffe9e9;
          &:hover {
            color: #ffd700;
          }
        }
        &.show .fa-caret-square-o-down {
          color: #ffd700;
        }
        &.show {
          display: block;
        }
        .bucket_option_list {
          padding: 5px 10px;
          background: rgba(0, 0, 0, 0.92);
          box-shadow: 0px 0px 3px rgba(255, 255, 255, 0.1);
          .bucket_option_item {
            color: #d6d6d6;
            font-size: 16px;
            margin-top: 10px;
            &:hover {
              color: #ffd700;
            }
            &:first-child {
              margin-top: 0px;
            }
          }
        }
      }
      &.sub_folder_dd{ 
       > .bucket_folder_list{display:none !important;}
       &.show_sub_bucket > .bucket_folder_list{display:block !important;}
      }
      .show_sub_bucket_list_icon {
        position: absolute;
        top: -4px;
        left: -20px;
        & .fa {
          font-size: 22px;
          transform:rotate(0);
          -webkit-transform:rotate(0);
          -moz-transform:rotate(0);
          transition:all ease 0.5s;
          -webkit-transition:all ease 0.5s;
          -moz-transition:all ease 0.5s;
            color: #ffe9e9;
        }
     }
     &.show_sub_bucket > .bucket_folder_name_wrp > .show_sub_bucket_list_icon > .fa{
       color:#ffd700;
        transform:rotate(90deg);
        -webkit-transform:rotate(90deg);
        -moz-transform:rotate(90deg);}
    }
  }
}
</style>